export default "__VITE_ASSET__D1pJBpFj__"